import { Box, ButtonProps, Container, Divider, Group, Stack, Text } from "@mantine/core"
import { ElementType } from "react"
import { brand } from "~/brand"

type FooterProps = {
  qualifyButton: ElementType<ButtonProps<"a">>
}

export const Footer = ({ qualifyButton: QualifyButton }: FooterProps) => (
  <Box sx={{ backgroundColor: brand.theme.darkblue }} pb="xl">
    <Divider color="grey" mb="xl" />
    <Container>
      <Group position="apart" align="flex-start">
        <Stack spacing={0}>
          <Text size="sm" weight="bold" sx={{ color: brand.theme.yellow }}>
            Can You Unlock
          </Text>
          <Text component="a" href="tel:1-888-546-6607" size="sm" sx={{ color: "white" }}>
            1-888-546-6607
          </Text>
          <Text component="a" href="mailto:info@canyouunlock.com" size="sm" sx={{ color: "white" }}>
            info@canyouunlock.com
          </Text>
        </Stack>

        <Stack spacing={0}>
          <Text size="sm" weight="bold" sx={{ color: brand.theme.yellow }}>
            Business hours
          </Text>
          <Text size="sm" sx={{ color: "white" }}>
            Monday to Friday: 9 AM to 5 PM
          </Text>
          <Text size="sm" sx={{ color: "white" }}>
            Eastern Time Zone
          </Text>
        </Stack>

        <QualifyButton />
      </Group>
    </Container>
  </Box>
)
